import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  IPostCashRequirementsRequestBody,
  IPostCashRequirementsResponseBody,
} from "./postCashRequirements.schema";

const URL = `reports/cash-requirements`;
export const postCashRequirements = (axios: IAxiosInstance) => {
  return async (requestBody: IPostCashRequirementsRequestBody) => {
    const response = await axios.noRetry.post<
      IApiResponse<IPostCashRequirementsResponseBody["data"]>
    >(URL, requestBody);
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
